export default "__VITE_ASSET__CTKeNB$O__"